import { SiteCode as WebAppSiteCode } from 'js/sign-components/generated/types/WebApp';
import { siteCodes } from 'js/sign-components/common/brand';
import { UnreachableError } from 'js/sign-components/common/ts-utils';

type RuntimeSiteCode = typeof siteCodes.fax | typeof siteCodes.sign;

let siteCode: RuntimeSiteCode | null = null;
export function useSiteCode(): RuntimeSiteCode {
  if (siteCode == null) {
    throw new Error('Missing siteCode');
  }

  return siteCode;
}
export function setSiteCode(code: WebAppSiteCode) {
  switch (code) {
    case 'F':
      siteCode = siteCodes.fax;
      return;
    case 'S':
      siteCode = siteCodes.sign;
      return;
    case 'W':
      siteCode = siteCodes.sign;
      return;
    default:
      throw new UnreachableError(code);
  }
}
